import {BOARD_ID} from '@/util/BoardConst';

export const BOARD_ID_PKG = BOARD_ID.BID_PODO_HOTEL_PKG;
export const BOARD_ID_ROOM = BOARD_ID.BID_PODO_HOTEL_ROOM;
export const BOARD_ID_PKG_NEW = BOARD_ID.BID_PODO_HOTEL_PKG_NEW;
export const BOARD_ID_DINING_NEW = BOARD_ID.BID_PODO_RESTAURANT_DETAIL;

export const BOARD_ID_DINING_RECOMMEND = BOARD_ID.BID_PODO_RESTAURANT_RECOMMEND;

export const BOARD_ID_PKG_NEW_ENG = BOARD_ID.BID_PODO_HOTEL_PKG_NEW_ENG;
